import React, { useContext, useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { DigitalWizardCustPageTemplate } from 'gw-portals-wizard-components-ui';
import { ModalNextContext } from '@jutro/components';
import { GooglePlacesLookupComponent } from 'cpmi-capability-googleplaces-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { useTranslator } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
// import { Contact } from 'gw-capability-fnol-common-react';
import { DateUtil } from '@xengage/gw-portals-util-js';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import moment from 'moment';

import { LoaderExt } from 'gw-components-platform-react';
import { publish } from '@jutro/events';
import usecpmiAnalytics from '../../../../hooks/usecpmiAnalytics';
import metadata from './WhatPage.metadata.json5';
import messages from '../../FNOLWC.messages';
import styles from './WhatPage.module.scss';
import Claim from '../../../cpmi_FNOL-common/models/Claim';
import Contact from '../../../cpmi_FNOL-common/models/Contact';
import Address from '../../../cpmi_FNOL-common/models/Address';
import useGoogleAnalytics from '../../../../hooks/useGoogleAnalytics';

function FNOLWCWhatPage(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const {
        wizardData: claimVM,
        updateWizardData,
        authHeader,
        userInfo,
        history: {
            location: { state },
        },
    } = props;
    
    // console.log(props.history.location.state.claimData.lossDate.toJSON());
    claimVM.lossDate=props.history.location.state.claimData.lossDate;
   
    //const claimVM=props.history.location.state.claimData;

    
    const ModalNext = useContext(ModalNextContext);

    const translator = useTranslator();
    const { FNOLService } = useDependencies('FNOLService');
    const { ClaimService } = useDependencies('ClaimService');
    const { ClaimDownloadService } = useDependencies('ClaimDownloadService');
    const [isLoading, setIsLoading] = useState(false);
    const [toggleValue, setToggleValue] = useState(false);
    const [empNotifDateMessage, setEmpNotifDateMessage] = useState({});
    const [countryAvailableValues, setCountryAvailableValues] = useState([]);
    const [dobMessage, setDobMessage] = useState({});
    const [country,setCountry]=useState(undefined);
    const [trackPageView] = usecpmiAnalytics();
    const [trackGAPageView] = useGoogleAnalytics();
    const [isGoogleLoad, setGoogleLoad] = useState(true);
    const {
        onValidate,
        isComponentValid,
        initialValidation,
        registerInitialComponentValidation,
    } = useValidation('FNOLWCWhatPage');
    // claimVM.onFastTrack = toggleValue;
    useEffect(
        () => {
            if (claimVM.value.onFastTrack) {
                setToggleValue(true);
            }
            claimVM.value = new Claim(claimVM.value);
            const lobExtension = claimVM.lobs.workersComp;
            const { injuryIncident } = lobExtension.value;

            _.set(
                lobExtension,
                'dateReportedToEmployer',
                new Date(_.get(lobExtension, 'dateReportedToEmployer.value')).toJSON() ||
                    DateUtil.currentDateAtMidnight().toJSON()
            );
           


            if (!injuryIncident.injured) {
                injuryIncident.injured = new Contact({
                    displayName: 'New person',
                    gender: null,
                    dateOfBirth: null,
                });
            }

            if (!injuryIncident.injured.primaryAddress) {
                injuryIncident.injured.initializePrimaryAddress();
            }

            if (!injuryIncident.injuredAddress) {
                injuryIncident.injuredAddress = new Address();
            }
            const countryCodes = [];
            claimVM.lobs.workersComp.injuryIncident.injuredAddress.country.aspects.availableValues.forEach((val) =>{
                if(val.code === "US" || val.code === "CA" || val.code === "MX"){
                    countryCodes.push({
                        code: val.code,
                        name: translator({
                            id: val.name,
                            defaultMessage: val.name,
                        })
                    })
                }
            })
            setCountryAvailableValues(countryCodes)
            updateWizardData(claimVM);
        },
        // Call once when page is mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    useEffect(() => {
        trackPageView('What Page', '/what');
    }, []);

    useEffect(() => {
        trackGAPageView('/what', 'FNOL What');
    }, []);

    const getFNOLdetailsData = ()=>{
        const policyNumber = _.get(claimVM.value, 'policy.policyNumber');
        const isClaimNumberAvailable = _.get(claimVM.value, 'claimNumber');
        if (!isClaimNumberAvailable) {
            return FNOLService.getFNOLDetails(
                policyNumber,
                claimVM.value,
                authHeader
            )
                .then(response => {
                    claimVM.value = new Claim(response);
                    return claimVM;
                })
                .catch(() => {
                    ModalNext.showAlert({
                        title: messages.wcCreateDraftErrorTitle,
                        message: messages.wcCreateDraftErrorMessage,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok,
                    }).catch(_.noop);
                    return false;
                })
                .finally(() => {
                    // setIsLoading(false);
                });
        }
        return claimVM;
    }

    useEffect(() => {
        getFNOLdetailsData(); 
    }, []);

    const onNext = useCallback(() => {
        const newClaimVM = Object.assign({}, claimVM.value);
        _.set(newClaimVM, 'documents', []);
        _.set(newClaimVM, 'onFastTrack', toggleValue);
        const dateReportedDate=_.get(newClaimVM,'lobs.workersComp.dateReportedToEmployer')

        if(dateReportedDate!==undefined && dateReportedDate!=="" && dateReportedDate!==null && dateReportedDate.year){
            const newDate = new Date(dateReportedDate.year,dateReportedDate.month,dateReportedDate.day).toISOString();
            _.set(newClaimVM,'lobs.workersComp.dateReportedToEmployer',newDate);
        }
        if(newClaimVM.lobs.workersComp.injuryIncident.injuredAddress.country !== "US"){
            newClaimVM.lobs.workersComp.injuryIncident.injuredAddress.zipCode = newClaimVM.lobs.workersComp.injuryIncident.injuredAddress.postalCode
            newClaimVM.lobs.workersComp.injuryIncident.injuredAddress.postalCode = undefined
        }
        return FNOLService.saveFNOLDetails(newClaimVM, authHeader)
            .then(response => {
                claimVM.value = new Claim(response);
                return claimVM;
            })
            .catch(() => {
                ModalNext.showAlert({
                    title: messages.fnolSaveDraftErrorTitle,
                    message: messages.fnolSaveDraftErrorMessage,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok,
                }).catch(_.noop);
                return false;
            })
            .finally(() => {
                // setIsLoading(false);
            });
    }, [FNOLService, ModalNext, authHeader, claimVM, toggleValue]);

    const renderUpload = useCallback(value => {
        value === 'yes' ? setToggleValue(true) : setToggleValue(false);
        publish(
            'JUTRO_TOPICS.BUTTON_CLICKED',
            'JUTRO_TOPICS.VALUE_CHANGED',
            'JUTRO_TOPICS.FIELD_BLUR',
            {
                path: '/fnol-wc7/what',
                title: 'FNOL What fasttrack',
            }
        );
    }, []);

    const handleError = useCallback((title, message) => {
        return ModalNext.showAlert({
            title: title,
            message: message,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok,
        }).catch(_.noop);
    }, []);

    const claimsDocUploadToken = useCallback(async () => {
        try {
            const uploadTokenID = await ClaimService.claimsDocUploadToken(
                [],
                authHeader
            );
            return uploadTokenID;
        } catch (e) {
            return handleError(
                commonMessages.errorUploadTitle,
                commonMessages.errorGenerateUploadToken
            );
        }
    }, [ClaimService, authHeader, handleError]);

    const handleDocumentsUpload = useCallback(
        async file => {
            setIsLoading(true);
            const documentMetaDataTemplate = {
                DocUID: '001',
                DocumentType: 'fnol',
                SecurityType: 'unrestricted',
                Status: 'approved',
                Author: userInfo?.email,
                claimNumber: claimVM.claimNumber.value,
                name: file.name,
                mimeType: file.type,
                sessionID: await claimsDocUploadToken(),
            };
            try {
                const data = await ClaimService.uploadDocument(
                    file,
                    documentMetaDataTemplate,
                    authHeader
                );

                const documentsArray = _.get(claimVM, 'documents.value') || [];
                documentsArray.push(data);
                const newClaimVM = _.clone(claimVM);
                _.set(newClaimVM, 'documents.value', documentsArray);
                updateWizardData(newClaimVM);
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                handleError(
                    commonMessages.errorUploadTitle,
                    commonMessages.uploadFailedMessage
                );
            }
        },
        [
            claimVM,
            claimsDocUploadToken,
            ClaimService,
            authHeader,
            updateWizardData,
            handleError,
        ]
    );
    const generateMoreInfoDocumentsOverrides = useCallback(() => {
        const documentUploadPath = 'value.documents';
        const documentUploadItems = _.get(claimVM, documentUploadPath, []);
        const overrides = documentUploadItems.map(
            (documentUploadItem, index) => {
                return {
                    [`documentNameLink${index}`]: {
                        href: handleDocumentDownload(documentUploadItem),
                        content: documentUploadItem.name,
                    },
                };
            }
        );
        return Object.assign({}, ...overrides);
    }, [claimVM]);

    const handleDocumentDownload = useCallback(
        item => {
            if (_.isNil(item)) {
                return null;
            }
            const { docUID, sessionID } = item;
            return ClaimDownloadService.getClaimDocument(docUID, sessionID);
        },
        [ClaimDownloadService]
    );

    const validateEmpNotifDate = e => {
        const dt = document.querySelector('input[id^="dateEmployerNotified"]');
        let lossDate = moment(
            moment.utc(claimVM.value.lossDate).format('MM-DD-YYYY')
        );
        const date = dt.getAttribute('value');
        const dateFormat = 'MM-DD-YYYY';

        const toDateFormat = moment(new Date(date)).format(dateFormat);
       
        if (
            moment(toDateFormat, dateFormat, true).isValid() &&
            moment(lossDate) > moment(toDateFormat)
        ) {
            setEmpNotifDateMessage(
                'Date you were notified cannot be before the date of loss.'
            );
        } else if (!moment(toDateFormat, dateFormat, true).isValid()) {
            setEmpNotifDateMessage(
                'Date must be in the correct format: MM/DD/YYYY'
            );
        } else {
            setEmpNotifDateMessage('');
        }
    };

    const verifyEmpNotifDate = () => {
        if (!_.isEmpty(empNotifDateMessage)) {
            return [empNotifDateMessage];
        }
        return [];
    };
    const validateDOB = e => {
        const dt = document.querySelector('input[id^="whatDOB"]');
        const date = dt.getAttribute('value');
        const dateFormat = 'MM-DD-YYYY';
        const toDateFormat = moment(new Date(date)).format(dateFormat);
        const today = moment().format('MM/DD/YYYY');
       
        if (
            moment(toDateFormat, dateFormat, true).isValid() === false &&
            date !== ''
        ) {
            setDobMessage('Date must be in the correct format: MM/DD/YYYY');
        }
        if (
            moment(today).diff(toDateFormat, 'months') < 12 &&
            moment(toDateFormat).isBefore(moment(today))
        ) {
            setDobMessage('Injured worker should be at least one year old.');
        }
        if (moment(toDateFormat).isSameOrAfter(moment(today))) {
            setDobMessage('Injured worker should be at least one year old.');
        }
        if (
            (moment(today).diff(toDateFormat, 'months') > 12 &&
            moment(toDateFormat).isBefore(moment(today)))||date===''
        ) {
            setDobMessage('');
        }
    };

    const conutryChange=(value)=>{
        setGoogleLoad(false)        
        setTimeout(() => {
            setTimeout(setGoogleLoad(true), 50);       
            setGoogleLoad(true)                                  
        }, 50);        
        setCountry(value);   
    }

    const checkDob = () => {
        if (!_.isEmpty(dobMessage)) {
            return [dobMessage];
        }
        return [];
    };

    const overrides = {
        '@field': {
            labelPosition: breakpoint === 'tablet' ? 'top' : 'left',
            phoneWide: {
                labelPosition: 'top',
            },
        },
        whatPageLoader: {
            // loaded: !isLoading,
            // loadingMessage: translator(messages.wcCreateDraftClaim),
            visible: isLoading,
            customClass: 'CoveragesLoader',
        },
        submitAsReportId: {
            label: translator(messages.wcReportOfInjuryLabel, {
                employersReport: (
                    <a
                        className="employerReport"
                        href="https://www.copperpoint.com/insurance-claims/workers-comp-claims-kit"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Employer's First Report of Injury
                    </a>
                ),
                Yes:(<span className={styles.boldText}>Yes</span>)
            }),
            labelPosition: 'left',
            onValueChange: renderUpload,
            controlClassName: toggleValue ? 'btnActive' : 'btnInactive',
            value: toggleValue,
        },
        uploadDocument: {
            visible: toggleValue,
        },
        fileuploader: {
            required: !(claimVM.documents.length > 0),
            labelPosition: 'top',
            visible: toggleValue,
            onUpload: handleDocumentsUpload,
            validationMessages: !(claimVM.documents.length > 0) ? [' '] : [],
        },
        fileUploadTypes: {
            visible: toggleValue,
        },
        duplicateClaimsContainer: {
            visible: claimVM.value.isDuplicateClaim === true,
        },
        dateEmployerNotified: {
            contentContainerClassName: 'empNotifDatePicker',
            onBlur: e => validateEmpNotifDate(e),
            validationMessages: verifyEmpNotifDate(),
        },
        whatDetailCauseOfIncident: {
        },
        whatPhoneNumber: {
            visible: !toggleValue,
            showRequired: false,
        },
        whatSocialSecurityNumber: {
            visible: !toggleValue,
        },
        whatDOB: {
            visible: !toggleValue,
            showRequired: false,
            // onValueChange: e => {checkDob(e)},
            onBlur: e => validateDOB(e),
            validationMessages: checkDob(),
        },
        whatGender: {
            visible: !toggleValue,
        },
        whatInjuredEmployeeSeparation: {
            visible: !toggleValue,
        },
        whatgoogleplaces: {
            visible: !toggleValue && isGoogleLoad,
            selectedCountry : country,
            showCountry:true,
            countryAvailableValues: countryAvailableValues,
            translator:translator,
            conutryChange: conutryChange
        },
        whatAddressLine1: {
            visible: !toggleValue,
        },
        whatAddressLine2: {
            visible: !toggleValue,
        },
        whatAddressLine3: {
            visible: !toggleValue,
        },
        whatCity: {
            visible: !toggleValue,
        },
        whatZipCode: {
            visible: !toggleValue,
        },
        whatState: {
            visible: !toggleValue,
        },
        whatBottomSeparation: {
            visible: !toggleValue,
        },
        uploadDocumentGrid: {
            visible: toggleValue,
        },
        ...generateMoreInfoDocumentsOverrides(),
    };

    const { claimStatus } = state || {};

    const validateClaimStatus = useCallback(() => {
        return (
            !_.isNil(claimStatus) &&
            claimStatus ===
                translator({
                    id: 'typekey.ClaimState.draft',
                    defaultMessage: 'Draft',
                })
        );
    }, [claimStatus, translator]);

    useEffect(() => {
        registerInitialComponentValidation(validateClaimStatus);
    }, [registerInitialComponentValidation, validateClaimStatus]);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            // validateDate:validateDate
            // verifyDOB,
            handleDocumentsUpload: handleDocumentsUpload,
        },
        resolveComponentMap: {
            googleplaces: GooglePlacesLookupComponent,
        },
    };

    return (
        <WizardPage
            disableNext={!isComponentValid}
            // skipWhen={initialValidation}
            onNext={onNext}
            showPrevious={false}
            template={DigitalWizardCustPageTemplate}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrides}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

FNOLWCWhatPage.propTypes = wizardProps;
export default withRouter(withAuthenticationContext(FNOLWCWhatPage));
